module.exports = __webpack_public_path__ + "static/media/back.c63d28dc.png";